/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import CommentModel from '@linc-technologies/linced-common/models/posts/comment';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr, belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Studentnotice from 'linced-learners/models/posts/studentnotice';

// Proto: posts.Comment.
export default class Comment extends CommentModel {
  declare [Type]: 'posts/comment';

  @belongsTo('posts/studentnotice', { async: true, inverse: 'comments' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;

  @computed('postType')
  // @ts-expect-error a getter for the post by type replaces the common postId alias.
  get post() {
    switch (this.postType) {
      case PostTypes.STUDENT_NOTICE:
        return this.studentNoticeId;
      default:
        return this.postId;
    }
  }

  // Avoid using direct relationships so that fellow students' comments can be
  // shown with no author details, without triggering a GetPerson which 404s.
  @attr('string', { defaultValue: '' })
  // @ts-expect-error a plain id replaces the common person relationship (see above).
  declare authorId: string;

  @computed('authorId', 'post.author.fullName')
  // @ts-expect-error a getter with a stub replaces the common authorId alias.
  get author() {
    if (!isEmpty(this.get('authorId.id'))) {
      // When the user writes a new comment, the `authorId` property is set to
      // the Person record / relationship locally (by the shared component).
      return this.authorId;
    }
    const author = this.store.peekRecord('person', this.authorId);
    if (!isEmpty(author)) {
      // We have the author's person record already.  Use it.
      return author;
    }
    // Return a dummy stub to prevent a network request which we know will 404.
    return {
      fullName: 'A Student',
      // md5(' ') is used here as `mp` is always the same icon anyway.
      image:
        'https://gravatar.com/avatar/7215ee9c7d9dc229d2921a40e899ec5f?d=mp&f=y',
    };
  }
}
